module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/product_detail/gallery_3-00d21c514400a4b7e21dc70bfcc33dda.png";